import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'wink-navigation-list',
  styleUrl: 'styles/navigation-list.default.scss',
  shadow: true,
})
export class NavigationList {
  @Element() host!: HTMLWinkNavigationListElement;

  @Prop() listTitle = '';
  @Prop() hasBoldLinks = false;

  render() {
    return (
      <Host>
        {this.listTitle && (
          <wink-paragraph appearance="caption" size="bold" class="navigation-list--title">
            {this.listTitle}
          </wink-paragraph>
        )}
        <ul class="navigation-list--list" part="list">
          <slot></slot>
        </ul>
      </Host>
    );
  }
}
